export function cls(...x) {
  return x.filter(Boolean).join(" ");
}
